export default __webpack_public_path__ + "static/media/colorIconHospital.cc92fdaa.svg";